import { ROUTES } from '@/router/routes'
import type { RouteLocationNormalizedLoaded } from 'vue-router'

/**
 * Resolve the case UUID when the app is on a case-detail route (any child of `/app/cases/:uuid`).
 *
 * @param route - Current Vue Router location (`path` and `params` are used)
 * @returns Case UUID string, or `null` when not on a case-detail route
 */
export function caseUuidFromAppCaseDetailRoute(
  route: Pick<RouteLocationNormalizedLoaded, 'path' | 'params'>
): string | null {
  const prefix = ROUTES.APP.CASES.CASE_DETAIL.ROOT.replace(':uuid', '')
  if (!route.path.startsWith(prefix)) {
    return null
  }
  const uuid = route.params.uuid
  return typeof uuid === 'string' && uuid.length > 0 ? uuid : null
}
